import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { toast as toast$1 } from 'react-toastify';
import ToastRender from './ToastRender.js';
import 'prop-types';
import '@elliemae/ds-classnames';
import '@elliemae/ds-icons/CheckmarkCircleFill';
import '@elliemae/ds-icons/WarningCircleFill';
import '@elliemae/ds-icons/InfoCircleFill';
import './ToastType.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var toast = Object.assign(function (_ref, options) {
  var type = _ref.type,
      messageTitle = _ref.messageTitle,
      messageText = _ref.messageText,
      rest = _objectWithoutProperties(_ref, ["type", "messageTitle", "messageText"]);

  return toast$1( /*#__PURE__*/React.createElement(ToastRender, {
    messageText: messageText,
    messageTitle: messageTitle,
    type: type
  }), _objectSpread(_objectSpread(_objectSpread({}, rest), options), {}, {
    type: type
  }));
}, _objectSpread(_objectSpread({}, toast$1), {}, {
  isActive: function isActive(id) {
    return toast$1.isActive(id);
  }
}));

export { toast };
//# sourceMappingURL=toast.js.map
